import React, { useEffect, useState } from 'react';
import { Alert, Card, Container, Spinner } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import axios from '../utils/api';

const InviteUnsubscribe = () => {
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = params.get('token');

    const runUnsubscribe = async () => {
      if (!token) {
        setError('Invalid unsubscribe link. Missing token.');
        setLoading(false);
        return;
      }

      try {
        const response = await axios.post('/api/friend-invites/unsubscribe', { token });
        setMessage(response.data?.message || 'Unsubscribe completed successfully.');
      } catch (unsubscribeError) {
        setError(unsubscribeError.response?.data?.detail || 'Unable to process unsubscribe request.');
      } finally {
        setLoading(false);
      }
    };

    runUnsubscribe();
  }, [params]);

  return (
    <Container className="py-5">
      <Card className="mx-auto shadow-sm border-0" style={{ maxWidth: '680px' }}>
        <Card.Body className="p-4">
          <h1 className="h4 mb-3">Invite Message Preferences</h1>
          {loading && (
            <div className="text-center py-3">
              <Spinner animation="border" />
            </div>
          )}
          {!loading && message && <Alert variant="success" className="mb-0">{message}</Alert>}
          {!loading && error && <Alert variant="danger" className="mb-0">{error}</Alert>}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default InviteUnsubscribe;
